import React from "react";

const About = () => {
  return (
    <main>
      <div className="divider">
        <img src="asset/ezcom.png" alt="" />
        <div className="prof-divider">
          <div className="border">
            <h1>Under Construction</h1>
          </div>
        </div>
      </div>
    </main>
  );
};
//#015871
export default About;
